import React, { useState } from "react";
import "./../styles/Login.css";
import NavLogin from "./NavLogin";
import { useNavigate, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import { loginUser } from "../utils/api";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("Role");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateInputs = () => {
    const newErrors = {};

    if (!username.trim()) {
      newErrors.username = "Username harus diisi";
    } else if (username.length < 2 || username.length > 20) {
      newErrors.username = "Username harus 2-20 karakter";
    } else if (!/^[a-zA-Z0-9._-]+$/.test(username)) {
      newErrors.username =
        "Username hanya boleh mengandung huruf, angka, dan karakter ._-";
    }

    if (!password.trim()) {
      newErrors.password = "Password harus diisi";
    }

    if (role === "Role") {
      newErrors.role = "Silakan pilih role";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearInputs = () => {
    setUsername("");
    setPassword("");
    setRole("Role");
    setErrors({});
  };

  const signIn = async () => {
    if (validateInputs()) {
      const payload = {
        username,
        password,
        role,
      };

      try {
        const response = await loginUser(payload);

        Swal.fire("Berhasil!", response.welcome_message, "success");

        localStorage.setItem("username", username);
        localStorage.setItem("userRole", role);
        localStorage.setItem("isLoggedIn", "true");

        const routes = {
          superadmin: "/admin",
          petani: "/petani",
          kebun: "/kebun",
          logistik: "/logistik",
          pabrik: "/pabrik",
        };

        if (routes[role]) {
          navigate(routes[role]);
        } else {
          Swal.fire("Error", "Role tidak valid!", "error");
        }
      } catch (error) {
        Swal.fire("Gagal!", error.message || "Login gagal", "error");
      }
    }
  };

  return (
    <div className="login-body">
      <form onSubmit={(e) => e.preventDefault()}>
        <section
          className="section"
          style={{
            padding: "1rem",
            maxWidth: "750px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div>
            <NavLogin />
            <div className="container">
              <div className="box">
                <article className="media">
                  <div className="media-content">
                    <div className="content">
                      <h1 className="title">Sign In</h1>
                      <div className="field has-addons">
                        <div style={{ width: "100%" }}>
                          <label className="Username">Username</label>
                          <div className="control has-icons-left">
                            <input
                              id="input-username"
                              className={`input ${
                                errors.username ? "is-danger" : ""
                              }`}
                              type="text"
                              placeholder="Username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                            />
                            <span className="icon is-small is-left">
                              <i className="fa fa-user"></i>
                            </span>
                          </div>
                          {errors.username && (
                            <p className="help is-danger">{errors.username}</p>
                          )}
                        </div>
                      </div>
                      <p className="help" style={{ fontSize: "12px" }}>
                        Pada Username, silakan masukkan 2-20 karakter, angka,
                        atau karakter khusus (._-)
                      </p>

                      <div className="field">
                        <label className="Password" htmlFor="password">
                          Password
                        </label>
                        <div className="control has-icons-left">
                          <input
                            id="input-password"
                            className={`input ${
                              errors.password ? "is-danger" : ""
                            }`}
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <span className="icon is-small is-left">
                            <i className="fa fa-lock"></i>
                          </span>
                        </div>
                        {errors.password && (
                          <p className="help is-danger">{errors.password}</p>
                        )}
                      </div>

                      <div className="field">
                        <label htmlFor="role">Role</label>
                        <div className="control has-icons-left">
                          <div className="select is-fullwidth">
                            <select
                              id="role"
                              className={errors.role ? "is-danger" : ""}
                              value={role}
                              onChange={(e) => setRole(e.target.value)}
                            >
                              <option value="Role">Role</option>
                              <option value="superadmin">Admin</option>
                              <option value="petani">Petani</option>
                              <option value="kebun">Kebun</option>
                              <option value="logistik">Logistik</option>
                              <option value="pabrik">Pabrik</option>
                            </select>
                          </div>
                          <span className="icon is-small is-left">
                            <i className="fa fa-caret-down"></i>
                          </span>
                        </div>
                        {errors.role && (
                          <p className="help is-danger">{errors.role}</p>
                        )}
                      </div>
                    </div>
                    <div
                      className="has-text-centered"
                      style={{ marginTop: "20px" }}
                    >
                      <nav className="level is-mobile">
                        <div className="level-left">
                          <button
                            className="level-item button"
                            style={{
                              backgroundColor: "#ff4500",
                              color: "#ffffff",
                              transition: "background-color 0.3s ease",
                            }}
                            onClick={signIn}
                          >
                            Sign In
                          </button>
                          <button
                            className="level-item button"
                            style={{
                              backgroundColor: "#ff4500",
                              color: "#ffffff",
                              transition: "background-color 0.3s ease",
                            }}
                            onClick={clearInputs}
                          >
                            Clear
                          </button>
                        </div>
                      </nav>
                      <hr />
                      <div className="has-text-centered">
                        <div className="nav-item">
                          <Link to="/lupakatasandi">Lupa Kata Sandi?</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
  );
};

export default Login;